import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SettingsCard from '../../../components/Settings/SettingsCard'
import AvatarImage from '../../account/avatar-image'
import headerStyles from '../../account/settings/ProfileHeaderCard.module.scss'

const DEFAULT_CHARITY_LOGO = '/images/default-business.png'

export default function CharityLogoCard({ logoUrl, onLogoChange }) {
  const { t } = useTranslation()

  return (
    <SettingsCard
      icon="camera"
      title={t('charities.settings.logo_title')}
      description={t('charities.settings.logo_description')}
    >
      <div className={headerStyles.header}>
        <div className={headerStyles.avatar}>
          <AvatarImage
            imageUrl={logoUrl || DEFAULT_CHARITY_LOGO}
            mediaAttachmentType="charity_logo"
            onChange={onLogoChange}
          />
        </div>
      </div>
    </SettingsCard>
  )
}

CharityLogoCard.propTypes = {
  logoUrl: PropTypes.string,
  onLogoChange: PropTypes.func.isRequired,
}
